export enum A11yProperty {
  AriaLabel = 'aria-label',
  AriaLabelledby = 'aria-labelledby',
  AriaDescribedby = 'aria-describedby',
  AriaErrormessage = 'aria-errormessage',
  AriaDetails = 'aria-details',
  AriaControls = 'aria-controls',
  AriaOwns = 'aria-owns',
  AriaFlowto = 'aria-flowto',
  AriaRoledescription = 'aria-roledescription',
  AriaModal = 'aria-modal',
  AriaOrientation = 'aria-orientation',
  AriaKeyshortcuts = 'aria-keyshortcuts',
  AriaValuenow = 'aria-valuenow',
  AriaValuemin = 'aria-valuemin',
  AriaValuemax = 'aria-valuemax',
  AriaValuetext = 'aria-valuetext',
  AriaLevel = 'aria-level',
  AriaPosinset = 'aria-posinset',
  AriaSetsize = 'aria-setsize',
  AriaColcount = 'aria-colcount',
  AriaColindex = 'aria-colindex',
  AriaColspan = 'aria-colspan',
  AriaRowcount = 'aria-rowcount',
  AriaRowindex = 'aria-rowindex',
  AriaRowspan = 'aria-rowspan',
  AriaHasPopup = 'aria-haspopup',
  AriaAutocomplete = 'aria-autocomplete',
  AriaLive = 'aria-live',
  AriaMultiselectable = 'aria-multiselectable',
  AriaPlaceholder = 'aria-placeholder',
  Tabindex = 'tabindex',
}